import React, { useMemo, useState, useEffect } from "react";

interface MasonryGridProps {
  columns: number;
  mobileColumns?: number;
  breakpoint?: number;
  children: React.ReactNode;
  className?: string;
}

const MasonryGrid: React.FC<MasonryGridProps> = ({
  columns,
  mobileColumns,
  breakpoint = 576,
  children,
  className,
}) => {
  const mobileCols = mobileColumns ?? columns;

  const [isDesktop, setIsDesktop] = useState(
    () => window.matchMedia(`(min-width: ${breakpoint}px)`).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${breakpoint}px)`);
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [breakpoint]);

  const effectiveCols = isDesktop ? columns : mobileCols;

  const items = React.Children.toArray(children);

  const columnArrays = useMemo(() => {
    const cols: React.ReactNode[][] = Array.from(
      { length: effectiveCols },
      () => [],
    );
    items.forEach((item, i) => cols[i % effectiveCols].push(item));
    return cols;
  }, [items, effectiveCols]);

  return (
    <div
      className={className}
      style={{ display: "flex", alignItems: "flex-start" }}
    >
      {columnArrays.map((col, i) => (
        <div key={i} style={{ flex: 1, minWidth: 0 }}>
          {col}
        </div>
      ))}
    </div>
  );
};

export default MasonryGrid;
